import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import { useMentorshipsContext } from 'hb-react/frontoffice/apps/Mentorships/contexts/MentorshipsContext';
import ErrorFocus from 'hb-react/shared/components/formik/components/ErrorFocus';
import { Textarea } from 'hb-react/shared/components/formik/components/inputs';

const TerminationForm = ({
  label,
  onCancel,
  onSubmit,
  placeholder,
  validations,
}) => {
  const { menteeLabel } = useMentorshipsContext();

  const placeholderOrDefault =
    placeholder ||
    s__(
      "Mentorships|Please provide a note as to why you are rejecting this %{menteeLabel}. Typical messages include: sorry, but I dont have time right now or letting them know why it isn't a good fit",
    ).i__({
      menteeLabel: menteeLabel.toLowerCase(),
    });

  const handleSubmit = (value) => {
    onSubmit(value.message);
  };

  return (
    <Formik initialValues={{ message: '' }} onSubmit={handleSubmit}>
      {(formik) => (
        <Form id="end-relationship-form" style={{ width: 'inherit' }}>
          <ErrorFocus />
          <Textarea
            id="message"
            name="message"
            placeholder={placeholderOrDefault}
            label={label}
            validate={validations}
            minHeight={180}
          />
          <Box justifyContent="flex-end">
            {onCancel && (
              <Box>
                <Button onClick={onCancel}>{__('Cancel')}</Button>
              </Box>
            )}
            <Button disabled={formik.isSubmitting} type="submit">
              {__('Submit')}
            </Button>
          </Box>
        </Form>
      )}
    </Formik>
  );
};

TerminationForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  label: PropTypes.string,
  validations: PropTypes.object,
  placeholder: PropTypes.string,
};

TerminationForm.defaultProps = {
  label: s__('Mentorships|Rejection reasons'),
  validations: { maxLength: 1000 },
};

export default TerminationForm;
